import axios from "axios";

export const skipInsuranceCoverageRequest = async (): Promise<void> => {
  await axios.post(`/api/checkins/insurance_coverages`, { skipped: true });
};

export const skipInsuranceCoverageNewRequest = async (): Promise<void> => {
  await axios.post(`/api/checkins/insurance_coverages_news`, { skipped: true });
};
